module.exports = __webpack_public_path__ + "img/ic_euro.57f5eec7.svg";